import api from 'api';
import { WEB_API_ROUTES } from 'api/api-routes';
import { schedule } from '.';
import { handleServerErrors } from 'utils/server-errors';
import { createThunk } from '../../utils/store-utils';
import { apiWrapper } from '../../api/apiWrapper';

export const thunks = {
  getRoutinesList: createThunk('routines/getRoutinesList', (studentId) =>
    apiWrapper.get(WEB_API_ROUTES.routine.routineList, {
      params: {
        student_id: studentId,
      },
    })
  ),

  getSchedule: createThunk(
    'schedule/getSchedule',
    ({ start, end, studentId }) =>
      apiWrapper.get(`${WEB_API_ROUTES.schedule.schedules}`, {
        params: {
          start,
          end,
          student_id: studentId,
        },
      })
  ),

  getPrivateLessonBookData: createThunk(
    'schedule/getPrivateData',
    async ({ date, preference = 'both' }, { dispatch }) => {
      {
        try {
          const response = await api.get(`${WEB_API_ROUTES.schedule.private}`, {
            params: {
              date,
            },
          });

          if (preference === 'first' || preference === 'both') {
            dispatch(
              schedule.actions.setFirstPreferenceData(response.data.data)
            );
          }

          if (preference === 'second' || preference === 'both') {
            dispatch(
              schedule.actions.setSecondPreferenceData(response.data.data)
            );
          }

          return response;
        } catch (err) {
          handleServerErrors(err);
          throw err;
        }
      }
    }
  ),

  requestLesson: createThunk(
    'schedule/requestLesson',
    ({ preferences, lessonId, studentId }) =>
      api.post(
        `${WEB_API_ROUTES.schedule.requestLesson}${lessonId ? '/' + lessonId : ''} `,
        {
          student_id: studentId,
          preferences,
        }
      )
  ),

  getPendingPrivateRequests: createThunk(
    'schedule/getPendingPrivateRequests',
    (studentId) =>
      api.get(`${WEB_API_ROUTES.schedule.pendingRequests}`, {
        params: {
          student_id: studentId,
        },
      })
  ),
};
